<template>
  <div>
    <div v-if="true" class="filter-menu">
      <div class="content">
        <div class="margin-bottom filter-boxes">
          <div class="flex-grow filter-box">
            <strong>Rows:</strong>
            <div>
              {{ countRows }} <span v-if="totalRows"> of {{totalRows}} </span>
            </div>
          </div>
          <div class="flex-grow filter-box">
            <MaterialText label="Search" v-model="search" />
          </div>
          <div class="flex-grow filter-box" v-if="sortby">
            <div style="margin-bottom: 8px; font-weight: 900">Sort by</div>
            <select v-model="sort">
              <option value="">[ No sorting ]</option>
              <template v-for="(column, id) in columns" class="flex-grow">
                <template v-if="typeof column.sortable == 'object'">
                  <option :value="id + ',asc'" :key="'sort-asc-' + id">
                    {{ column.name }} - Ascending
                  </option>
                  <option :value="id + ',desc'" :key="'sort-desc-' + id">
                    {{ column.name }} - Descending
                  </option>
                </template>
              </template>
            </select>
          </div>
          <div
            v-for="(filter, id) in filterList"
            class="flex-grow filter-box"
            :key="id"
          >
            <div style="margin-bottom: 8px; font-weight: 900">
              {{ filter.name ? filter.name : id }}
            </div>
            <div class="margin-right" v-if="filter.mode == 'text'">
              <input type="text" v-model="values[id].text" />
              <template v-if="filter.allowEmpty">
                <div>
                  <input type="checkbox" v-model="values[id].showEmpty" /> Find
                  empty
                </div>
              </template>
            </div>
            <div class="margin-right" v-if="filter.mode == 'choices'">
              <div v-show="filter.open">
                <div v-on:click="toggleChoiceList(id)" style="cursor: pointer">
                  Close
                </div>
                <div v-for="(item, i) in filter.list" :key="i">
                  <input type="checkbox" v-model="values[id][i]" />
                  {{ item }}
                </div>
              </div>
              <div
                v-show="!filter.open"
                v-on:click="toggleChoiceList(id)"
                style="cursor: pointer"
              >
                <template v-if="choices[id]">
                  Selected: {{ choices[id] }}
                </template>
                <template v-else> Showing all </template>
              </div>
            </div>

            <div class="margin-right" v-if="filter.mode == 'options'">
              <select v-model="values[id].value">
                <option value="">[ All ]</option>
                <option value="1">Denmark</option>
                <option value="2">Sweden</option>
              </select>
            </div>

            <div class="margin-right" v-if="filter.mode == 'custom'">
              <input v-model="values[id].value" type="checkbox" />
            </div>

            <div class="margin-right" v-if="filter.mode == 'number'">
              <select v-model="values[id].operator" class="small-margin-right">
                <option value=""></option>
                <option value="=">Equals</option>
                <option value=">">More than</option>
                <option value="<">Less than</option>
              </select>
              <input
                v-show="values[id].operator"
                v-model="values[id].value"
                class="short"
                type="number"
              />
            </div>
          </div>
          <div class="filter-box">
            <slot name="filters" />
          </div>
        </div>
      </div>
    </div>
    <table>
      <thead v-bind:class="{ scrolled: scrollY > 100 && fullpage }">
        <tr>
          <th
            v-for="(column, id) in columns"
            :class="column.class"
            :style="'width: ' + column.width + '%'"
            :key="id"
          >
            {{ column.name ? column.name : id }}
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          :data-testid="row.ID"
          v-for="(row, i) in filteredRows"
          class="row"
          v-show="showPage(i)"
          :class="
            `${row.options.disabled ? 'disabled' : '' }`
          "
          :key="i"
        >
          <td
            v-for="(column, columnId) in columns"
            :class="column.class"
            :style="[{
                'width':column.width + '%',
                'color':row.fontColor ? row.fontColor : 'auto',
                'background-color':row.bgColor ? row.bgColor : '#fff',
                'font-weight':row.fontWeight ? row.fontWeight : 'auto',
                'max-width': columnId == 'customer_comments' && '180px'
            }]"
            :key="columnId"
          >
            <span class="column-name-hint" style="font-weight: 900">{{
              column.name ? column.name : columnId
            }}</span>

            <template v-if="row[columnId] != null">
              <template v-if="column.type == 'dot'">
                <div
                  class="dot"
                  v-bind:class="{
                    green: !!row[columnId],
                    red: !row[columnId],
                  }"
                ></div>
              </template>
              <template v-if="column.type == 'datetime'">
                <Format type="date" :value="row[columnId]" :time="true" />
              </template>
              <template v-if="column.type == 'flag'">
                <Flag :localeid="row[columnId]" />
              </template>
              <template v-if="column.type == 'image'">
                <div style="width: 90px" class="text-center thumbnail">
                  <img :src="row[columnId]" style="max-width: 80px" />
                  <div class="image-wrapper">
                    <img :src="row[columnId]" style="max-height: 300px" />
                  </div>
                </div>
              </template>
              <template v-if="row[columnId].type == 'progress'">
                <Progress
                  :progress="row[columnId].progress"
                  :total="row[columnId].total"
                />
              </template>
              <template v-if="row[columnId].type == 'issue_fix'">
                <IssueReasonModal :order="row[columnId]" />
              </template>
              <template
                v-if="
                  ['image', 'flag', 'dot', 'datetime'].indexOf(column.type) ==
                    -1
                "
              >
                <template v-if="typeof row[columnId] == 'object'">
                  <div
                    v-html="row[columnId].html"
                    v-if="row[columnId].type == 'html'"
                  ></div>

                  <a
                    v-if="row[columnId].type == 'link'"
                    target="_blank"
                    :href="row[columnId].url"
                    >{{ row[columnId].title }}</a
                  >

                  <div
                    v-if="
                      ['order-link', 'order'].indexOf(row[columnId].type) >= 0
                    "
                    style="display: flex; align-items: center"
                  >
                    <OrderLink
                      :id="row[columnId].order_id"
                      />
                  </div>

                  <div v-if="row[columnId].type == 'customer'">
                    <CustomerLink :customer="row[columnId].customer" />
                  </div>

                  <div v-if="row[columnId].type == 'stylist'">
                    <StylistLink :stylist="row[columnId].stylist" />
                  </div>
                </template>
                <template v-else>
                  <template v-if="column.editable">
                    <input
                      :disabled="saving"
                      type="text"
                      v-on:keyup.enter="save(row.rowId, columnId)"
                      v-model="row[columnId]"
                    />
                    <button
                      :disabled="saving"
                      class="small-margin-left"
                      v-on:click="save(row, columnId)"
                    >
                      Save
                    </button>
                  </template>
                  <template v-else>
                    {{ row[columnId] ? column.prefix : "" }}{{ row[columnId]
                    }}{{ row[columnId] ? column.suffix : "" }}
                  </template>
                </template>
                <template v-if="column.type == 'json'">
                  <div v-for="(value, key) in row[columnId]" :key="key">
                    {{ key }}: {{ value }}
                  </div>
                </template>
              </template>
            </template>
            <template v-else> - </template>
          </td>
          <td
            class="text-right"
            :style="[{
                'background-color':row.bgColor ? row.bgColor : '#fff',
            }]">
            <!-- <Dropdown> -->
            <span v-for="(menuItem, index) in row.menu" :key="index">
              <a
                target="_blank"
                :href="menuItem.url"
                :disabled="menuItem.disabled"
                v-if="menuItem.url"
              >
                <button class="smaller white light small-margin-left">
                  {{ menuItem.name }}
                </button>
              </a>

              <router-link
                :to="{
                  path: menuItem.routerLink,
                  query: { id: row.styling_order_id || row.id, key: row.key },
                }"
                v-if="menuItem.routerLink"
              >
                <button class="smaller white light">
                  {{ menuItem.name }}
                </button>
              </router-link>

              <button
                class="smaller white light small-margin-left"
                :disabled="menuItem.disabled"
                v-on:click="menuItem.onClick(row)"
                v-if="menuItem.onClick"
              >
                {{ menuItem.name }}
              </button>
            </span>
            <!-- </Dropdown> -->
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="usePagination" class="pagination margin-top">
      <button
        class="gray small small-margin-right"
        v-on:click="prevPage()">Prev</button>
      <div
        class="set-page"
        v-for="(page, index) in getPages"
        v-bind:class="{ active: currentPage == page }"
        v-on:click="setPage(page)"
        :key="index"
      >
        {{ page }}
      </div>
      <button
        class="gray small small-margin-left"
        v-on:click="nextPage()">Next</button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import IssueReasonModal from '@/components/IssueReasonModal.vue'

export default {
  components: { IssueReasonModal },
  props: ['columns', 'rows', 'tabKeys', 'filters', 'perpage', 'fullpage', 'sortby', 'totalRecords'],
  data: () => ({
    saving: false,
    values: {},
    visible: 0,
    page: 1,
    scrollY: 0,
    filterList: {},
    sort: '',
    search: '',
    rowBackgroundColor: '',
    wp_url: process.env.VUE_APP_WP_URL
  }),
  computed: {
    countRows () {
      return this.filteredRows.length
    },
    totalRows () {
      return this.totalRecords
    },
    choices () {
      var result = {}
      for (var i in this.filterList) {
        result[i] = 0
        for (var j in this.values[i]) {
          if (this.values[i][j]) {
            result[i]++
          }
        }
      }
      return result
    },
    getPages () {
      var list = []
      var pages = this.countPages()
      for (var i = 1; i <= pages; i++) {
        list.push(i)
      }
      return list
    },
    currentPage () {
      if (this.page < 1) {
        // this.page = 1
        this.setPage(1)
      } else if (this.page > this.countPages()) {
        // this.page = this.countPages()
        this.setPage(this.countPages())
      }
      return this.page
    },
    useFilter () {
      if (!this.filters) {
        return false
      }
      return Object.keys(this.filters).length > 0
    },
    usePagination () {
      return !!this.perpage
    },
    filteredRows () {
      var result = []
      var visible = 0
      this.setVisible(visible)
      // this.visible = 0

      var rows = this.rows
      if (this.sort) {
        rows = this.sortRows(rows)
      }

      for (var i in rows) {
        var row = rows[i]
        var addRow = true

        if (!row.options) {
          row.options = {}
        }

        for (var id in this.filters) {
          var filter = this.filters[id]
          var value = this.values[id]

          if (value) {
            switch (filter.mode) {
              case 'custom':
                if (value.value && !filter.function(row)) {
                  addRow = false
                }
                break
              case 'text':
                var term = value.text

                if (value.showEmpty && row[id]) {
                  addRow = false
                } else if (term && row[id]) {
                  if (row[id].toLowerCase().indexOf(term.toLowerCase()) == -1) {
                    addRow = false
                  }
                }
                break
              case 'number':
                if (value.operator) {
                  switch (value.operator) {
                    case '=':
                      if (row[id] != value.value) {
                        addRow = false
                      }
                      break
                    case '>':
                      if (row[id] < value.value) {
                        addRow = false
                      }
                      break
                    case '<':
                      if (row[id] > value.value) {
                        addRow = false
                      }
                      break
                  }
                }
                break
              case 'choices':
                var localList = []
                for (var f in filter.list) {
                  for (var v in value) {
                    if (v == f && value[v]) {
                      localList.push(filter.list[f])
                    }
                  }
                }
                if (localList.length > 0 && localList.indexOf(row[id]) == -1) {
                  addRow = false
                }
                break
            }
          }
        }

        if (addRow || row._always) {
          result.push(row)
          visible += 1
          this.setVisible(visible)
          // this.visible++
        }
      }

      return result.filter((row) => {
        var search = this.search.toLowerCase()

        if (search) {
          for (var i in row) {
            var value = row[i]

            if (typeof value === 'object') {
              for (var j in value) {
                if (
                  String(value[j])
                    .toLowerCase()
                    .indexOf(search) >= 0
                ) {
                  return true
                }
              }
            } else if (
              String(value)
                .toLowerCase()
                .indexOf(search) >= 0
            ) {
              return true
            }
          }

          return false
        }

        return true
      })
    }
  },
  methods: {
    setVisible (value) {
      this.visible = value
    },
    save (row, columnId) {
      var id = row.rowId
      var value = row[columnId]
      var url = row[columnId + 'Url']
      var data = {}
      data[columnId] = value
      Vue.apiPatch(
        url,
        {
          data: data
        },
        {
          before: () => (this.saving = true),
          always: () => (this.saving = false),
          callback: (data) => alert('Saved')
        }
      )
    },
    setFilter (filters) {
      this.resetAllFilters()
      for (var i in filters) {
        var setFilter = filters[i]
        switch (this.filterList[i].mode) {
          case 'custom':
            this.values[i].value = setFilter.value
            break
          case 'text':
            this.values[i].text = setFilter.text
            this.values[i].showEmpty = setFilter.showEmpty
            break
          case 'number':
            this.values[i].operator = setFilter.operator
            this.values[i].value = setFilter.value
            break
        }
      }
    },
    resetAllFilters () {
      for (var i in this.filterList) {
        this.resetFilter(i)
      }
    },
    resetFilter (id) {
      if (!this.values[id]) {
        return
      }
      switch (this.filterList[id].mode) {
        case 'custom':
          this.values[i].value = false
          break
        case 'number':
          this.values[id].operator = ''
          this.values[id].value = 0
          break
        case 'text':
          this.values[id].text = ''
          this.values[id].showEmpty = false
          break
        case 'choices':
          this.values[id] = false
          break
      }
    },
    toggleChoiceList (id) {
      if (!this.filterList[id].open) {
        this.$set(this.filterList[id], 'open', true)
      } else {
        this.$set(this.filterList[id], 'open', false)
      }
    },
    showPage (i) {
      if (!this.usePagination) {
        return true
      }
      var from = (this.currentPage - 1) * this.perpage
      var to = this.currentPage * this.perpage
      return i >= from && i < to
    },
    setPage (page) {
      this.page = page
    },
    countPages () {
      return Math.ceil(this.visible / this.perpage)
    },
    nextPage () {
      this.page++
    },
    prevPage () {
      this.page--
    },
    isUsingFilter (value) {
      if (typeof value === 'object') {
        return Object.keys(value).length > 0
      }
      return !!value
    },
    nullableValues () {
      for (var id in this.filters) {
        switch (this.filters[id].mode) {
          case 'text':
            this.$set(this.values, id, {
              text: '',
              showEmpty: false
            })
            break
          case 'number':
            this.$set(this.values, id, {
              operator: '',
              value: 0
            })
            break
          case 'choices':
            this.$set(this.values, id, [])
            break
          case 'custom':
            this.$set(this.values, id, {
              value: false
            })
            break
        }
      }
    },
    handleScroll (event) {
      this.scrollY = window.scrollY
    },
    setSorting (sorting) {
      this.sort = sorting.column + ',' + (sorting.descending ? 'desc' : 'asc')
    },
    sortRows (rows) {
      const method = this.sort.split(',')
      const column = method[0]
      const direction = method[1]
      const arr = []

      for (var row of rows) {
        arr.push(row)
      }

      arr.sort((a, b) => new Date(a[column]).getTime() - new Date(b[column]).getTime())

      return direction === 'asc' ? arr : arr.reverse()
    }

  },
  created () {
    for (var i in this.filters) {
      this.$set(this.filterList, i, this.filters[i])
    }
    this.nullableValues()
    window.addEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="less">
table.with-filters {
  margin-top: 120px;
}
table {
  thead {
    &.scrolled {
      display: block;
      position: fixed;
      top: 0px;
      left: 0px;
      right: 0px;
      z-index: 600;
    }
  }
  tbody tr {
    td {
      position: relative;
      .column-name-hint {
        top: 6px;
        transition: 200ms;
        position: absolute;
        // transform: scale(0, 0);
        opacity: 0;
      }
    }
    &:hover {
      td {
        .column-name-hint {
          transform: none;
          opacity: 0.4;
          pointer-events: none;
        }
      }
    }
  }
}
.thumbnail {
  position: relative;
  .image-wrapper {
    display: none;
  }
  &:hover .image-wrapper {
    pointer-events: none;
    display: block;
    position: absolute;
    left: 100%;
    top: -100px;
    border: 1px solid #afafaf;
  }
}
.pagination {
  justify-content: center;
  display: flex;
  align-items: center;
  .set-page {
    margin-left: 5px;
    margin-right: 5px;
    border-radius: 4px;
    border: 1px solid #afafaf;
    cursor: pointer;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    &.active {
      background: #efefef;
    }
  }
}
.filter-boxes {
  display: flex;
  border: 1px solid #efefef;
  .filter-box {
    padding: 30px;
    border-left: 1px solid #efefef;
    &:nth-child(1) {
      border-left: none;
    }
  }
}

.table-row-pink {
  background-color: #ffebeb;
}
.table-row-blue {
  background-color: #e8f3ff;
}
.table-row-grey {
  background-color: #f2f2f2;
}
button.light {
  background: #e6e6e6 !important;
}
</style>
